
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.83 6.205V5.13a2.17 2.17 0 114.34 0v1.076H5.83zm6.34 2V5.13a4.17 4.17 0 00-8.34 0v3.076h8.34z","fill":"#6A6482"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.316 6.025H.684v5.586a7.316 7.316 0 0014.633 0V6.025zm-5.497 4.78a1.82 1.82 0 01-1.15 1.692v2.284H7.332v-2.284a1.82 1.82 0 112.487-1.692z","fill":"#6A6482"}})])
          )
        }
      }
    